(() => {
  const normalize = value => String(value || '').trim().toLowerCase();
  function sizeMatches(size, weight, specialty) {
    let value = normalize(size).replace(/\s+/g, '').replace(/–/g, '-');
    const sizeAliases = {'kecil':'small','sedang':'medium','besar':'large','ekstrakecil':'extrasmall','sangatkecil':'extrasmall','x-kecil':'extrasmall','xkecil':'extrasmall','ekstrabesar':'extralarge','sangatbesar':'extralarge','x-besar':'extralarge','xbesar':'extralarge'};
    value = sizeAliases[value] || value;
    if (!weight) return true;
    if (value === 's-m') return weight < 75;
    if (value === 'm-l') return weight >= 70 && weight <= 90;
    if (value === 'l-xl') return weight > 85;
    if (specialty) return false;
    if (/^(extra-?small|x-?small|xs\b|grom)/.test(value)) return weight < 55;
    if (/^(extra-?large|x-?large|xl\b)/.test(value)) return weight > 85;
    if (/^(small|s$)/.test(value)) return weight >= 55 && weight <= 70;
    if (/^(medium|m$)/.test(value)) return weight >= 65 && weight <= 80;
    if (/^(large|l$)/.test(value)) return weight >= 75 && weight <= 90;
    return false;
  }
  function setupMatches(product, setup) {
    const tags = product.tags.map(normalize);
    const title = normalize(product.handle).replace(/-/g, ' ') + ' ' + normalize(product.title);
    if (/bundle|replacement|side fin|sidefin|centre fin|center fin|infill|plug|screw/.test(title)) return false;
    if (setup === 'longboard') return tags.includes('fcs ii longboard fins') || tags.includes('longboard fins');
    if (tags.includes('longboard fins') || tags.includes('fcs ii longboard fins')) return false;
    if (setup === 'quad_rears') return tags.includes('quad rears') || /quad rear/.test(title);
    if (tags.includes('quad rears') || /quad rear/.test(title)) return false;
    if (setup === 'tri_quad') return tags.includes('tri-quads') && /tri[ -]?quad|5[ -]?fin/.test(title);
    if (setup === 'quad') return tags.includes('quads') && !/tri[ -]?quad|5[ -]?fin/.test(title);
    if (setup === 'keel') return tags.includes('keel') || /keel/.test(title);
    if (setup === 'twin') return tags.includes('twin fin') && !/keel/.test(title);
    return tags.includes('thruster') && !/tri[ -]?quad|twin|keel/.test(title);
  }
  function systemMatches(product, system) {
    const tags = product.tags.map(normalize);
    if (system === 'longboard') return tags.includes('fcs ii longboard fins') || tags.includes('longboard fins');
    return tags.includes(system === 'ii' ? 'fcs ii' : 'fcs i fins');
  }
  function init() {
    document.querySelectorAll('[data-jungle-fin-finder]').forEach(finder => {
      if (finder.dataset.ready) return;
      finder.dataset.ready = 'true';
      const labels = JSON.parse(finder.querySelector('[data-fin-labels]').textContent);
      const form = finder.querySelector('[data-fin-form]');
      const system = finder.querySelector('[data-fin-system]');
      const setup = finder.querySelector('[data-fin-setup]');
      const weight = finder.querySelector('[data-fin-weight]');
      const family = finder.querySelector('[data-fin-family]');
      const remember = finder.querySelector('[data-fin-remember]');
      const submit = finder.querySelector('[data-fin-submit]');
      const status = finder.querySelector('[data-fin-status]');
      const results = finder.querySelector('[data-fin-results]');
      const browse = finder.querySelector('[data-fin-browse]');
      let request;
      const root = finder.dataset.root.replace(/\/?$/, '/');
      const storageKey = 'jungle-fin-box-preferences';
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey));
        if (saved && ['ii', 'i', 'longboard'].includes(saved.system)) {
          system.value = saved.system;
          setup.value = saved.setup;
          remember.checked = true;
        }
      } catch {}
      function sync() {
        request?.abort();
        submit.disabled = false;
        status.textContent = '';
        results.replaceChildren();
        const longboard = system.value === 'longboard';
        const singleOption = setup.querySelector('[value="longboard"]');
        singleOption.hidden = !longboard;
        singleOption.disabled = !longboard;
        if (longboard) setup.value = 'longboard';
        else if (setup.value === 'longboard') setup.value = '';
        setup.disabled = longboard || system.value === 'unknown';
        weight.disabled = longboard || setup.value === 'quad_rears' || system.value === 'unknown';
        family.disabled = longboard || !['thruster', 'quad', 'tri_quad'].includes(setup.value);
        const note = longboard || setup.value === 'quad_rears' ? labels.length : ['twin', 'keel'].includes(setup.value) ? labels.specialty : labels.sizing;
        finder.querySelector('[data-fin-sizing]').textContent = note;
        if (!remember.checked) { try { localStorage.removeItem(storageKey); } catch {} }
      }
      function productCard(product, variants, choices, index) {
        const card = document.createElement('article');
        card.className = 'jungle-fin-finder__card';
        const image = document.createElement('img');
        if (product.image) {
          image.src = product.image;
          image.alt = product.title;
          image.width = 360;
          image.height = 360;
          image.loading = 'lazy';
          card.append(image);
        }
        const heading = document.createElement('h3');
        heading.textContent = product.title;
        const reason = document.createElement('p');
        reason.textContent = choices;
        const stock = document.createElement('p');
        stock.dataset.finStock = '';
        stock.textContent = labels.available;
        const price = document.createElement('p');
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `JungleFinMatch-${index}`;
        label.htmlFor = select.id;
        label.textContent = labels.options;
        const link = document.createElement('a');
        link.textContent = labels.view;
        variants.forEach((variant, variantIndex) => {
          const option = document.createElement('option');
          option.value = String(variantIndex);
          option.textContent = `${variant.title} — ${variant.price}`;
          select.append(option);
        });
        function choose() {
          const variant = variants[Number(select.value)];
          const url = new URL(variant.url, window.location.origin);
          if (url.origin !== window.location.origin) return;
          link.href = url.href;
          price.textContent = variant.price;
          stock.textContent = `${labels.available} · ${labels.size}: ${variant.size}`;
        }
        select.addEventListener('change', choose);
        card.append(heading, reason, stock, price, label, select, link);
        choose();
        return card;
      }
      form.addEventListener('change', sync);
      weight.addEventListener('input', sync);
      sync();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        request?.abort();
        results.replaceChildren();
        if (system.value === 'unknown') { status.textContent = labels.unknown; return; }
        if (!form.reportValidity()) return;
        const choices = {system:system.value, setup:setup.value, family:family.disabled ? '' : family.value, weight:weight.disabled ? 0 : Number(weight.value)};
        if (remember.checked) {
          try { localStorage.setItem(storageKey, JSON.stringify({system:choices.system, setup:choices.setup})); } catch {}
        }
        const handles = {ii:'fcs-ii', i:'fcs-i-dual-tab-fins', longboard:'fcs-ii-longboard-fins'};
        const tags = {thruster:'thruster', quad:'quads', tri_quad:'tri-quads', quad_rears:'quad-rears', twin:'twin-fin', keel:'keel'};
        const url = new URL(`${root}collections/${handles[choices.system]}${tags[choices.setup] ? '/' + tags[choices.setup] : ''}`, window.location.origin);
        url.searchParams.set('filter.v.availability', '1');
        browse.href = url.href;
        url.searchParams.set('view', 'jungle-fin-data');
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const controller = new AbortController();
        request = controller;
        status.textContent = labels.loading;
        submit.disabled = true;
        try {
          const catalogue = [];
          let next = url;
          for (let page = 0; next && page < 10; page++) {
            const response = await fetch(next.href, {signal:controller.signal});
            if (!response.ok) throw new Error('Unavailable');
            const data = await response.json();
            if (!Array.isArray(data.products)) throw new Error('Invalid response');
            catalogue.push(...data.products);
            next = data.next ? new URL(data.next, window.location.origin) : null;
            if (next) {
              if (next.origin !== window.location.origin || !next.pathname.startsWith(root + 'collections/')) throw new Error('Invalid page');
              next.searchParams.set('view', 'jungle-fin-data');
              next.searchParams.set('filter.v.availability', '1');
              if (preview) next.searchParams.set('preview_theme_id', preview);
            }
          }
          if (controller.signal.aborted) return;
          const seen = new Set();
          const matches = catalogue.filter(product => {
            if (seen.has(product.url)) return false;
            seen.add(product.url);
            return systemMatches(product, choices.system) && setupMatches(product, choices.setup) && (!choices.family || normalize(product.handle).includes(choices.family) || product.tags.some(tag => normalize(tag) === choices.family));
          }).map(product => ({product, variants:product.variants.filter(variant => sizeMatches(variant.size, choices.weight, ['twin','keel'].includes(choices.setup)))})).filter(match => match.variants.length).slice(0,6);
          const description = [system.options[system.selectedIndex].text, setup.options[setup.selectedIndex].text, choices.family ? family.options[family.selectedIndex].text : ''].filter(Boolean).join(' · ');
          matches.forEach((match, index) => results.append(productCard(match.product, match.variants, description, index)));
          status.textContent = matches.length ? labels.results.replace('__count__', matches.length) : labels.empty;
        } catch (error) {
          if (error.name !== 'AbortError') { status.textContent = labels.error; console.warn('Jungle Surf fin matcher:', error.message); }
        } finally {
          if (request === controller) submit.disabled = false;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('jungle:collection:updated', init);
})();

